import { render, staticRenderFns } from "./first_quiz.vue?vue&type=template&id=0e8aa358&scoped=true&"
import script from "./first_quiz.vue?vue&type=script&lang=js&"
export * from "./first_quiz.vue?vue&type=script&lang=js&"
import style0 from "./first_quiz.vue?vue&type=style&index=0&id=0e8aa358&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8aa358",
  null
  
)

export default component.exports